<template>
<v-card class='grey lighten-4' >
  <v-card-title class='overline my-0 py-0 grey lighten-3' >
    <span v-if='practitioner' v-text='practitioner.full_name' />
    <span v-if='space' class='ml-1' >@ {{space.title}}</span>
    <v-spacer/>
    <v-btn small icon @click="$emit('close')" >
      <v-icon>close</v-icon>
    </v-btn>
  </v-card-title>
  <v-divider/>
  <v-card-text>
    <v-card v-for='(day, index) in dow' v-if='hours' :key='index' tile class="ma-3 elevation-4" >
      <v-card-title class='grey lighten-2 overline py-1 my-0' >{{day}}</v-card-title>
      <v-list class='elevation-0 pa-0' dense >
        <v-divider></v-divider>
        <v-list-tile
          v-if='hrSet !== "" && hours[dowLookup[index]]'
          v-for='hrSet in getHours(index)'
          :key='hrSet'>
          <v-list-tile-content @click='setHours(dowLookup[index], hrSet)' >
            <v-list-tile-title>
              <v-icon class='mr-2' >edit</v-icon> {{hrSet}}
            </v-list-tile-title>
          </v-list-tile-content>
          <v-list-tile-action >
            <v-btn @click='deleteHours(dowLookup[index], hrSet)' icon ><v-icon>delete</v-icon></v-btn>
          </v-list-tile-action>
        </v-list-tile>
        <v-list-tile v-else :key='index' >
          <v-list-tile-content>
            Not available for appointments
          </v-list-tile-content>
        </v-list-tile>
        <v-layout >
          <v-flex class='text-xs-right' >
          <v-btn flat small @click='showAddHours(dowLookup[index])' >
          <v-icon>add</v-icon>Add hours</v-btn>
          </v-flex>
        </v-layout>
      </v-list>
    </v-card>
  </v-card-text>
  <v-divider/>
  <v-card-actions >
    <v-btn flat @click="$emit('close')" >Cancel</v-btn>
    <v-spacer />
    <v-switch v-model='autosave' label='auto-save' dense small />
    <v-btn v-if='!autosave' @click='saveHours' :loading='servicesSaveHrsRequest.loading' color='primary' >Save</v-btn>
  </v-card-actions>

  <v-dialog v-model="rangePickerDialog" max-width="300px">
    <v-card>
      <v-card-text>
        <time-range-picker
          v-model='activeRange'
          :min-start-time='minStartTime'
          :initial-start-time='activeStartTime'
          :initial-end-time='activeEndTime' >
        </time-range-picker>
      </v-card-text>
      <v-card-actions  >
        <v-btn @click='rangePickerDialog=false' flat>Cancel</v-btn>
        <v-spacer></v-spacer>
        <v-btn color='primary' v-if='editmode' @click="editHours(activeDay, originalEditRange, activeRange)" :disabled='!activeRange' >Edit</v-btn>
        <v-btn color='primary' v-else @click="addHours(activeDay, activeRange)" :disabled='!activeRange' >Add</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</v-card>
</template>

<script>
import TimeRangePicker from './TimeRangePicker'
import {mapGetters} from 'vuex'

export default {
  name: 'OperatingHours',
  components: {TimeRangePicker},
  props: {
    value: { type: Object, default: () => { return {} } },
    autosave: { type: Boolean, default: false }
  },
  data () {
    return {
      rangePickerDialog: false,
      reqId: 'hrs-update-request',
      dow: ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'],
      dowLookup: ['mon', 'tues', 'wed', 'thurs', 'fri', 'sat', 'sun'],
      activeStartTime: '09:00',
      activeEndTime: '09:00',
      activeRange: null,
      activeDay: null,
      editmode: false,
      originalEditRange: null,
      defaultMinStartTime: '01:00',
      minStartTime: '01:00',
      hours: {}
    }
  },
  mounted () {
    this.hours = this.value
  },
  watch: {
    value () {
      this.hours = this.value
    },
    hours () {
      this.$emit('input', this.hours)
    },
    watchString () {
      if (this.autosave) {
        this.saveHours()
      }
    }
  },
  computed: {
    ...mapGetters(['getSpaceById', 'getPractitionerById']),
    space () {
      return this.getSpaceById(this.hours.space)
    },
    practitioner () {
      return this.getPractitionerById(this.hours.practitioner_id)
    },
    servicesSaveHrsRequest () {
      return this.$store.getters.getRequestById(this.reqId, true)
    },
    watchString () {
      let hours = this.hours
      return `${hours.mon}${hours.tues}${hours.wed}${hours.thurs}${hours.fri}${hours.sat}${hours.sun}`
    }
  },
  methods: {
    showAddHours (dayKey) {
      this.activeDay = dayKey
      this.editmode = false
      this.rangePickerDialog = true
      let hrs = this.hours[dayKey]
      if (hrs) {
        let lastRange = hrs.split('|').pop()
        let lastTime = lastRange.split('-').pop()
        this.activeStartTime = lastTime
        this.minStartTime = lastTime
      }
      // this.activeStartTime = startTime
    },
    setHours (dayKey, rangeString) {
      this.activeDay = dayKey
      this.originalEditRange = rangeString
      this.rangePickerDialog = true
      this.editmode = true
      if (rangeString) {
        this.activeStartTime = rangeString.split('-')[0]
        this.activeEndTime = rangeString.split('-')[1]
        this.minStartTime = this.defaultMinStartTime
      }
    },
    getHours (index) {
      try {
        return this.hours[this.dowLookup[index]].split('|')
      } catch (error) {
        return []
      }
    },
    editHours (dayKey, original, newHours) {
      this.hours[dayKey] = this.hours[dayKey].replace(original, newHours)
      this.rangePickerDialog = false
    },
    addHours (dayKey, formattedRange) {
      let hrs = this.hours[dayKey]
      if (hrs.length > 1) {
        this.hours[dayKey] = hrs + '|' + formattedRange
      } else {
        this.hours[dayKey] = formattedRange
      }
      this.rangePickerDialog = false
    },
    deleteHours (dayKey, hourString) {
      let hrs = this.hours[dayKey]
      hrs = hrs.replace(`|${hourString}|`, '')
      hrs = hrs.replace(`|${hourString}`, '')
      hrs = hrs.replace(`${hourString}`, '')
      this.hours[dayKey] = hrs
    },
    saveHours () {
      let data = {
        'id': this.hours.id,
        'mon': this.hours.mon,
        'tues': this.hours.tues,
        'wed': this.hours.wed,
        'thurs': this.hours.thurs,
        'fri': this.hours.fri,
        'sat': this.hours.sat,
        'sun': this.hours.sun
      }
      // let payload = this.extractFields(OperationHourFields, data)

      this.$appointmentguru
        .resource('practitioner.services.hours')
        .id(this.reqId)
        .save(data.id, data)
    }
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// OperatingHours.vue?3e6f6c00